<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="选择老人" required prop="userName">
                <el-input v-model="addForm.userName" placeholder="选择老人" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="护理套餐" required prop="checkinSetmealCode">
                <el-select v-model="addForm.checkinSetmealCode" placeholder="请选择护理套餐" @change="setmealChange" style="width:100%">
                  <el-option
                      v-for="item in setmealList"
                      :key="item.checkinSetmealCode"
                      :label="item.name"
                      :value="item.checkinSetmealCode">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.univalence }}(元/月)</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="预计入住时间">
                <el-date-picker
                    v-model="addForm.beginTimePlan"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="预计入住时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="预计退住时间">
                <el-date-picker
                    v-model="addForm.endTimePlan"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="预计退住时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="入住类型" required>
                <el-select v-model="addForm.type" placeholder="请选择入住类型" style="width:100%">
                  <el-option
                      v-for="(item,i) in typeValue"
                      :key="i"
                      :label="item"
                      :value="i">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="实际费用" required>
                <el-input v-model="addForm.feiTrue" placeholder="输入实际费用"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>


    <GetElderly ref="myGetElderly" v-show="showModalGetElderly"
                v-on:closeElderly="showModalGetElderly=false"
                v-on:setElderly="setElderly"></GetElderly>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import GetElderly from "@/views/Elderly/Comm/ElderlyInsSigning";


export default {
  name: 'Add',
  props:['setmealList'],
  data() {
    return {

      showModalGetElderly: false,

      loading: false,
      typeValue:['正式入住'],

      datetimerangeValue:'',


      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        elderlyCode:'',
        userName:'',

        checkinSetmealCode:'',

        type:0,
        beginTimePlan:'',
        endTimePlan:'',

        feiTrue:0,

      },
      pickerOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      rules:{

        type:[
          { required: true, message: '请选择入住类型', trigger: 'blur' },
        ],
        checkinSetmealCode:[
          { required: true, message: '请选择护理套餐', trigger: 'blur' },
        ],

      },


    }
  },
  components: {
    GetElderly
  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init();
    },
    setElderly(row){
      this.addForm.elderlyCode=row.elderlyCode;
      this.addForm.userName = row.name;
    },


    setmealChange(val){
      //console.log(val);
      for(let i=0;i<this.setmealList.length;i++){
        if(this.setmealList[i].checkinSetmealCode == val){
          this.addForm.feiTrue = this.setmealList[i].univalence;
        }
      }
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },
    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Checkin/AddDayCare",
        data: this.addForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          })
    },


  }
}


</script>
<style lang="scss" scoped>

</style>
